// extracted by mini-css-extract-plugin
export default {"exitStageLeft":"Modes_exitStageLeft__bzKH6"};